// checks whether has storage or not

import React from 'react';

const hasStorage = (WrappedComponent) => {
    class hasStorageHOC extends React.Component {
        supportsSessionStorage;
        // constructor(props){
        //     super(props);

        // }

        // perform simple test to see if localStorage is supported
        checkBrowserSupportsSessionStorage = () => {
            const checkKey = "test";
            try {
                sessionStorage.setItem(checkKey, "test");
                sessionStorage.removeItem(checkKey);
                return true;
            } catch (e) {
                return false;
            }
        }
        saveToSessionStorage = (key, item) => {
            // if (this.supportsSessionStorage) {
            sessionStorage.removeItem(key);
            sessionStorage.setItem(key, JSON.stringify(item));
            //     return true;
            // }
            // return false;

        }
        getFromSessionStorage = (key) => {
            // if (this.supportsSessionStorage) {
            return JSON.parse(sessionStorage.getItem(key));
            // }
            // return null;
        }
        removeFromSessionStorage = (key) => {
            // if (this.supportsSessionStorage) {
            sessionStorage.removeItem(key);
            //     return true;
            // }
            // return false;
        }
        resetSessionStorage = () => {
            sessionStorage.clear();
        }
        componentDidMount() {
            this.supportsSessionStorage = this.checkBrowserSupportsSessionStorage();
            //this.checkBrowserSupportsSessionStorage();
        }

        render() {
            return (
                <WrappedComponent resetSessionStorage={this.resetSessionStorage} saveToSessionStorage={this.saveToSessionStorage} getFromSessionStorage={this.getFromSessionStorage} removeFromSessionStorage={this.removeFromSessionStorage} {...this.state} {...this.props} />
            );
        }
    }
    return hasStorageHOC;
}
export default hasStorage;


// WEBPACK FOOTER //
// ./src/hoc/hasStorage.js